import React, { useEffect, useRef, useState } from 'react';
import { NavLink, useNavigate, useParams } from 'react-router-dom';
import { getAssets, softDeleteAsset, setToPublic, setToArchive, setToRestore, setStorageClass, setAclClass } from '../../Services/AssetService';
import { InputSwitch } from 'primereact/inputswitch';
import Swal from 'sweetalert2';
import MTable from '../../Components/MTable/MTable';
import { uuid } from '../../Utils/Utils';
import { useDispatch, useSelector } from "react-redux";
import EditButton from '../../Components/Button/EditButton';
import CustomButton from '../../Components/Button/CustomButton';
import Modal from '../../Components/Layout/Modal';
import Overlay from '../../Components/Overlay/Overlay';
import { setTabPosition, setTabMenuCode } from "../../Stores/Action/AppAction";
import { getMenus } from '../../Services/MenuService';
import { isEmpty, truncate } from "../../Utils/Utils";
import parser from 'html-react-parser'; 

const obsURL = process.env.REACT_APP_OBS_URL;
const { $ } = window;

const resModal = '#restore-modal';
const strModal = '#storage-modal';
const aclModal = '#acl-modal';
const viewModal = '#view-modal';
const msgSpeed = [
  'Restores the objects within 1 to 5 minutes.',
  'Restores the objects within 3 to 5 hours.'
]
const msgStorage = [
  'Optimized for frequently accessed (multiple time per month) data such as small and essential files that require low latency.',
  'Optimized for infrequently accessed (once per month) data that requires low latency.',
  'Optimized for rarly accessed (once per year) data.'
];
const msgAcl = [
  'Indicates that a bucket or object can be accessed only by its owner.',
  'Everyone can obtain the content and metadata of the object.'
]
let processingId = -1;

const AssetScreen = () => {
  const { pageState } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const mTable = useRef();
  const { userInfo } = useSelector(state => state.auth);
  const { tabPosition, tabMenuCode } = useSelector(state => state.app);
  const [ menu, setMenus] = useState({ menus: [] });

  let [count, setCount] = useState(30);
  let [speed, setSpeed] = useState(msgSpeed[1]);
  let [storage, setStorage] = useState(msgStorage[0]);
  let [acl, setAcl] = useState(msgAcl[0]);

  const [state, setState] = useState({
    asset_id: 0,
    restoreSpeed: 'Standard',
    storageClass: 'Standard',
    aclClass: 'AclPrivate',
    periode: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,17,18,19,20,21,22,23,24,25,26,27,28,29,30],
    options: [],
    processing: false,
    file: {},
    asset: {},
    fileType: '',
    fileIndex: 0,
    processingNumber: 1,
  });


  const changeTabPosition = (tabPosition, menuCode) => {    
    dispatch(setTabMenuCode(`function.function_code:${menuCode}`))
    dispatch(setTabPosition(tabPosition));
  }

  const onCloseModal = () => {
    setState({ ...state, file: {}, fileType: '', fileIndex: 0, asset_id: 0 });
    setSpeed(msgSpeed[1]);
    $(resModal).modal("hide");
  }

  const onCloseStrModal = () => {
    setState({ ...state, file: {}, fileType: '', fileIndex: 0, asset_id: 0 });
    setStorage(msgStorage[0]);
    $(strModal).modal("hide");
  }

  const onCloseAclModal = () => {
    setState({ ...state, file: {}, fileType: '', fileIndex: 0, asset_id: 0 });
    setAcl(msgAcl[0]);
    $(strModal).modal("hide");
  }

  const onCloseViewModal = () => {
    setState({ ...state, asset: {}, file: {}, fileType: '', fileIndex: 0, asset_id: 0 });
    $(viewModal).modal("hide");
  }

  const startProcessing = (processingNumber) => {
      processingId = setTimeout(() => {
          setState({ ...state, processing: true, processingNumber });
      }, 150);
  };

  const stopProcessing = (processingNumber) => {
      clearTimeout(processingId);
      setState({ ...state, processing: false, processingNumber });
  };
  
  const onEdit = item => () => {
    navigate("edit/" + item._id);
  };

  const onArchive = (item) => {
    setToArchive(item._id, res => {
      if (res.status == 200 || res.status == 201) {
        Swal.fire({
          icon: 'success',
          title: 'Set Archive success',
          text: 'Data has been changed!'
        }).then(res => { mTable.current.refresh(); });
      }
    }, error => {
      Swal.fire({
        icon: 'error',
        title: 'Set Archive fail',
        text: error.response.data.message
      });
    });
  }

  const showRestoreModal = (item) => {
    if(item.file === undefined){
      Swal.fire({
        icon: 'warning',
        title: 'Restoring File',
        text: 'Enable to Restore!, the file is not exists please upload one of following type of files [Standard, High, Raw, Low]'
      });
    }else{
      let ftype = '';
      Object.keys(item.file).map((key, i) => {
        if (i === 0) ftype = key;
      });
      
      setState({ ...state, file: item.file, asset_id: item._id, fileType: ftype, fileIndex: 0 });
      setTimeout(() => {
          $(resModal).modal("show");
      }, 300);
    }
  }

  const showViewModal = (item) => {
      setState({ ...state, asset: item, file: item.file, asset_id: item._id});
      setTimeout(() => {
          $(viewModal).modal("show");
      }, 300);
  }

  const showStorageModal = (item) => {
    if(item.file === undefined){
      Swal.fire({
        icon: 'warning',
        title: 'Archived File',
        text: 'Enable to change the Storage Class!, the file is not exists please upload one of following type of files [Standard, High, Raw, Low]'
      });
    }else{
      let ftype = '';
      Object.keys(item.file).map((key, i) => {
        if (i === 0) ftype = key;
      });
      setState({ ...state, file: item.file, asset_id: item._id, fileType: ftype, fileIndex: 0 });
      setTimeout(() => {
          $(strModal).modal("show");
      }, 300);
    }
  }

  const showAclModal = (item) => {
    if(item.file === undefined){
      Swal.fire({
        icon: 'error',
        title: 'Can\'t Archived File',
        text: 'Enable to set the Access Roles!, the file is not exists please upload one of following type of files [Standard, High, Raw, Low]'
      });
    }else{
      let ftype = '';
      Object.keys(item.file).map((key, i) => {
        if (i === 0) ftype = key;
      });
      setState({ ...state, file: item.file, asset_id: item._id, fileType: ftype, fileIndex: 0 });
      setTimeout(() => {
          $(aclModal).modal("show");
      }, 300);
    }
  }

  const onRestore = (param) => {
    const { restoreSpeed, fileType, fileIndex } = state;
    const body = {
      days: count,
      speed: restoreSpeed,
      fileType: fileType,
      fileIndex: fileIndex
    }

    startProcessing();

    setToRestore(param, body, res => {
      if (res.status == 200 || res.status == 201) {
        Swal.fire({
          icon: 'success',
          title: 'Set Restore success',
          text: 'Data has been changed!'
        }).then(res => { mTable.current.refresh(); $(resModal).modal("hide"); stopProcessing();});
      }
    }, error => {
      let err = '';
      err = error.response.data?.message ? error.response.data.message : error.response.data.fileType
      Swal.fire({
        icon: 'error',
        title: 'Set Restore fail',
        text: err
      }).then(stopProcessing());
    });
  }

  const onStoreClass = (param) => {
    
    const { storageClass, fileType, fileIndex } = state;
    const body = {
      storageClass: storageClass,
      fileType: fileType,
      fileIndex: fileIndex
    }

    startProcessing();
    
    setStorageClass(param, body, res => {
      if (res.status == 200 || res.status == 201) {
        Swal.fire({
          icon: 'success',
          title: 'Set storage class success',
          text: 'Data has been changed!'
        }).then(res => { mTable.current.refresh(); $(strModal).modal("hide");stopProcessing();});
      }
    }, error => {
      let err = '';
      err = error.response.data?.message ? error.response.data.message : error.response.data.fileType

      Swal.fire({
        icon: 'error',
        title: 'Set storage class fail',
        text: err
      }).then(stopProcessing());
    });
  }
  
  const onSetAcl = (param) => {
    
    const { aclClass, fileType, fileIndex } = state;
    const body = {
      aclType: aclClass,
      fileType: fileType,
      fileIndex: fileIndex
    }

    startProcessing();
    
    setAclClass(param, body, res => {
      if (res.status == 200 || res.status == 201) {
        Swal.fire({
          icon: 'success',
          title: 'Set ACL success',
          text: 'Data has been changed!'
        }).then(res => { mTable.current.refresh(); $(aclModal).modal("hide");stopProcessing();});
      }
    }, error => {
      let err = '';
      err = error.response.data?.message ? error.response.data.message : error.response.data.fileType

      Swal.fire({
        icon: 'error',
        title: 'Set ACL fail',
        text: err
      }).then(stopProcessing());
    });
  }

  const onChangeStatus = (id, param) => {
    const body = {
      status: param
    }
    
    startProcessing();

    setToPublic(id, body, res => {
      if (res.status == 200 || res.status == 201) {
        Swal.fire({
          icon: 'success',
          title: 'Set '+ param +' success',
          text: 'Data has been changed!'
        }).then(res => { mTable.current.refresh(); stopProcessing();});
      }
    }, error => {
      Swal.fire({
        icon: 'warning',
        title: param +' File',
        text: error.response.data.message
      }).then(stopProcessing());
    });
  }

  const changeCount = (e) => {
    const re = /^[0-9\b]+$/;

    if (e.target.value === '' || re.test(e.target.value)) {
      count = (e.target.value >= 30 ? 30 : (e.target.value <=1 ? 1: e.target.value));
      setCount(count);
    }
  }

  const incrementCount = () => {
    count = count + 1 >= 30 ? 30 : count + 1;
    setCount(count);
  }
  const decrementCount = () => {
    count = count - 1 <= 1 ? 1 : count - 1;
    setCount(count);
  }

  const setExtSpeed = () => {
    setState({ ...state, restoreSpeed: 'Standard'});
    setSpeed(msgSpeed[1]);
  }

  const setStdSpeed = () => {
    setState({ ...state, restoreSpeed: 'Expedited'});
    setSpeed(msgSpeed[0]);
  }

  const setStdClass = () => {
    setState({ ...state, storageClass: 'Standard' });
    setStorage(msgStorage[0]);
  }

  const setInfClass = () => {
    setState({ ...state, storageClass: 'Infrequent' });
    setStorage(msgStorage[1]);
  }
  
  const setArhClass = () => {
    setState({ ...state, storageClass: 'Archive' });
    setStorage(msgStorage[2]);
  }

  const setPrivateClass = () => {
    setState({ ...state, aclClass: 'AclPrivate' });
    setAcl(msgAcl[0]);
  }

  const setPublicClass = () => {
    setState({ ...state, aclClass: 'AclPublicRead' });
    setAcl(msgAcl[1]);
  }
  

  const setTypeFile = e => {
    let data = e.target.value.split('_');
    setState({ ...state, fileType: data[0], fileIndex: data[1] });
  }

  // const parser = new DOMParser();
  // const parsedDocument = parser.parseFromString(string , 'text/html');

  const columns = [
    { id: uuid(), title: 'Asset ID', field: '_id', sortable: true },
    { id: uuid(), title: 'Title', field: 'title', sortable: true },
    {
      id: uuid(),
      title: 'Files',
      sortable: false,
      render: data => {
        return <div><img src={process.env.REACT_APP_OBS_URL + data.thumbnail.preview_url} style={{ width: 32, height: 32, objectFit: 'cover' }} /></div>;
      },
    },
    {
      id: uuid(),
      title: 'Description',
      field: 'description',
      type: 'html',
      sortable: false,
      render: data => {
        return parser(data.description);
      },
  },
    {
      id: uuid(),
      title: 'Type',
      sortable: false,
      render: data => {
        return data.type.type_name;
      },
    },
    // {
    //   id: uuid(),
    //   title: 'Storage',
    //   sortable: true,
    //   render: data => {
    //     return data.function.function_name;
    //   },
    // },
    { id: uuid(), title: 'Brand', field: 'brand', sortable: true },
    {
      id: uuid(),
      title: 'Category',
      sortable: false,
      render: data => {
        return data.category.category_name;
      },
    },
    { id: uuid(), title: 'Month', field: 'asset_month', sortable: true },
    { id: uuid(), title: 'Year', field: 'asset_year', sortable: true },
    { id: uuid(), title: 'Date Upload', field: 'created_on', sortable: true },
    { id: uuid(), title: 'Status', field: 'status', sortable: true },
    // {
    //   id: uuid(),
    //   title: 'Active',
    //   field: 'is_active',
    //   sortable: true,
    //   options: [
    //     {
    //       label: 'Active',
    //       value: true
    //     },
    //     {
    //       label: 'Inactive',
    //       value: false
    //     }
    //   ],
    //   render: data => {
    //     return <InputSwitch checked={data.is_active} onChange={(e) => changeStatus(data._id, e.value)} />;
    //   },
    // },
    {
      id: uuid(),
      title: 'Action',
      render: item => {
        return (
          <div>
            {
              item.status == 'Draft' && userInfo.role_id == 1 && (<div>
                  <EditButton title="Edit" onClick={onEdit(item)} />
                  <CustomButton title="View" type="default" icon='fas fa-eye' onClick={() => showViewModal(item)} />
                  <CustomButton title="Publish" type="default" icon='fa fa-podcast' onClick={() => onChangeStatus(item._id, 'Publish')} />
                  {/* <CustomButton title="Archived" type="default" icon='fas fa-archive' onClick={() => onArchive(item)} /> */}
                  <CustomButton title="Archived" type="default" icon='fas fa-archive' onClick={() => showStorageModal(item)} />
                </div>
                )
            }
            {
              item.status == 'Publish' && userInfo.role_id == 1 && (<div>
                <EditButton title="Edit" onClick={onEdit(item)} />
                <CustomButton title="View" type="default" icon='fas fa-eye' onClick={() => showViewModal(item)} />
                <CustomButton title="ACL" type="default" icon='fas fa-archive' onClick={() => showAclModal(item)} />
                <CustomButton title="Draft" type="default" icon='fa fa-eye-slash' onClick={() => onChangeStatus(item._id, 'Draft')} />
                {/* <CustomButton title="Archived" type="default" icon='fas fa-archive' onClick={() => onArchive(item)} /> 
                <CustomButton title="Archived" type="default" icon='fas fa-archive' onClick={() => showStorageModal(item)} /> */}
                </div>
              )
            }
            {
              item.status == 'Infrequent' && userInfo.role_id == 1 && (<div>
                  <CustomButton title="Archived" type="default" icon='fas fa-archive' onClick={() => showStorageModal(item)} />
                </div>
                )
            }
            {
              item.status == 'Archive' && userInfo.role_id == 1 && (<CustomButton title="Restore" type="default" icon='fas fa-archive' onClick={() => showRestoreModal(item)} />)
            }
            {
              item.status == 'Restore' && userInfo.role_id == 1 && (<div>
                  {/*<EditButton title="Edit" onClick={onEdit(item)} />
                  <CustomButton title="Set Public" type="default" icon='fas fa-cogs' onClick={() => onChangeStatus(item._id, 'Publish')} />
                  <CustomButton title="Archived" type="default" icon='fas fa-archive' onClick={() => onArchive(item)} /> */}
                  <CustomButton title="Archived" type="default" icon='fas fa-archive' onClick={() => showStorageModal(item)} />
                </div>
                )
            }
            {
              item.status == 'Mix' && userInfo.role_id == 1 && (<div>
                <CustomButton title="View" type="default" icon='fas fa-eye' onClick={() => showViewModal(item)} />
                <CustomButton title="Archived" type="default" icon='fas fa-archive' onClick={() => showStorageModal(item)} />
                <CustomButton title="Restore" type="default" icon='fas fa-archive' onClick={() => showRestoreModal(item)} />
                </div>)  
            }
          </div>
        );
      },
    },
  ];

  const onAddData = () => {
    navigate("add/new");
  }

  const changeStatus = (username, status) => {
    const body = {
      is_active: status
    }

    softDeleteAsset(username, body, res => {
      if (res.status == 200 || res.status == 201) {
        Swal.fire({
          icon: 'success',
          title: 'Change status success',
          text: 'Data has been changed!'
        }).then(res => { mTable.current.refresh(); });
      }
    }, error => {
      Swal.fire({
        icon: 'error',
        title: 'Change status fail',
        text: 'Data can not be changed!'
      });
    });
  }

  useEffect(() => {
    getMenus({ perpage: 100, filter: `menu_level:1,is_active:true`, order: `sort`, direction: `asc` }).then((res) => {
      setMenus({ menus: res.data.data});
    });

    if(userInfo.role_id != 1){
      navigate('/');
    }
  }, []);

  const propsTable = { defaultSort: '_id', columns, getData: getAssets, showIndex: true, showAddButton: true, onAddData, enableFilter: true, filterRule: 'filter' };
  const { file, processing, asset_id, processingNumber, customFilter, asset } = state
  const { menus } = menu;

  return (
    <div className="content-wrapper">
      <div className="content-header">
        <div className="container-fluid">
            <div className="row mb-2">
                <div className="col-sm-6">
                    <ol className="breadcrumb float-sm-left">
                        <li className="breadcrumb-item"><NavLink to="/home">Home</NavLink></li>
                        <li className="breadcrumb-item active">{pageState && pageState.charAt(0).toUpperCase() + pageState.slice(1)} Asset</li>
                    </ol>
                </div>
            </div>
        </div>
      </div>
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className='col-md-12'>
              <div className='card card-default card-tabs'>
                <div className='card-header p-1 pt-1'>
                  {/* <div className='card-title'><i className='fa fa-user-tag' /> List Asset</div> */}
                  <ul className="nav nav-tabs" id="custom-tabs-five-tab" role="tablist">
                    {
                        menus?.map((item, i) => (
                          <li key={'tab_' + i} className="nav-item">
                            <a onClick={() => changeTabPosition(1 + parseInt(i), item.menu_code)} className={`nav-link m-text-bold ${tabPosition == (1 + parseInt(i)) && 'active'}`} id={'asset_data_' + (1 + parseInt(i))} data-toggle="pill" href={'#asset_tab_' + (1 + parseInt(i))} role="tab" aria-controls="custom-tabs-five-overlay" aria-selected="false">{item.menu_name}</a>
                          </li>  
                        ))
                    }
                  </ul>
                </div>
                <div className='card-body'>
                  <MTable ref={mTable} {...propsTable} customFilter={tabMenuCode} order="_id" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div style={{ height: 20 }} />
      <Modal id={resModal} title="Restore Object" onClose={onCloseModal} onAction={() => onRestore(asset_id)} btnActionName="Restore" btnActionDisabled={false}  modalSize={'modal-lg'}>
        <Overlay display={processing} />
        <div className='col-md-12'>
          <div className='mb-3 row'>
            <div className='col-md-12'>
              <div className="alert alert-primary form-inline" role="alert" style={{ display: `inline-flex`}}>
                <i className="fas fa-info-circle mt-1 me-2"></i>
                Use the Days parameter to specify the retention period (from 1 to 30 days) of an object and the Tier parameter to specify the time spent on restoring the object.
              </div>
            </div>
          </div>
          <div className="mb-3 row">
            <div className="col-sm-12">
            <label htmlFor="staticEmail" className="col-form-label">Object Lists</label>  
              <table className='table'>
                <thead>
                  <tr>
                    <th></th>
                    <th>File Name</th>
                    <th>Storage Class</th>
                    <th>Size</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    !isEmpty(file) && Object.keys(file).map((key, i) => 
                      Array.isArray(file[key]) && file[key].map((item, j) => 
                        <tr key={'class'+j}>
                          <td><input className="form-check-input" type="radio" name="flexRadioClass" id={'flexRadioClass_'+j} defaultChecked={j === 0 ? true : false} value={key+'_'+j} disabled={item?.storage_class === 'Archive' ? false : true} onClick={setTypeFile} /></td>
                          <td>{truncate(item?.preview_url.split("/").pop().split('_')[1], 50)}</td>
                          <td>{item?.storage_class}</td>
                          <td>{item?.size  +' ' + item?.unit}</td>
                        </tr>
                      ))
                  }
                  {
                    !isEmpty(file) && Object.keys(file).map((key, i) => 
                      !Array.isArray(file[key]) && (
                        <tr key={'class'+i}>
                          <td><input className="form-check-input" type="radio" name="flexRadioClass" id={'flexRadioClass_'+i} defaultChecked={i === 0 ? true : false} value={key+'_'+i} disabled={file[key]?.storage_class === 'Archive' ? false : true} onClick={setTypeFile} /></td>
                          <td>{truncate(file[key]?.preview_url.split("/").pop().split('_')[1], 50)}</td>
                          <td>{file[key]?.storage_class}</td>
                          <td>{file[key]?.size  +' ' + file[key]?.unit}</td>
                        </tr>
                      ))
                  }
                </tbody>
              </table>
            </div>
          </div>
          <div className="mb-3 row">
              <label htmlFor="staticEmail" className="col-sm-4 col-form-label">Validity Period</label>
              <div className="col-sm-8">
                <button type="button" className="btn btn-outline-secondary" style={{ borderRadius: 0, verticalAlign: `top`, border: `1px solid #ced4da`, marginRight: `-1px`, width: 35 }} onClick={decrementCount}>-</button>
                <input type="input" className="form-control" id="inputPassword" value={count} onChange={changeCount} style={{ display: `inline-flex`, width: `33%`, borderRadius: 0, textAlign: `center` }} />
                <button type="button" className="btn btn-outline-secondary" style={{ borderRadius: 0, verticalAlign: `top`, border: `1px solid #ced4da`, marginLeft: `-1px`, width: 35 }} onClick={incrementCount}>+</button>
                <label htmlFor="staticEmail" style={{ paddingLeft: 10 }} className="col-sm-4 col-form-label">days</label>
              </div>
          </div>
          <div className="mb-3 row">
              <label htmlFor="staticEmail" className="col-sm-4 col-form-label">Speed</label>
              <div className="col-sm-8">
                <div className="form-check" style={{ paddingTop: 8, width: `33%`, display: `inline-block` }}>
                  <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1" onClick={setStdSpeed} />
                  <label className="form-check-label" htmlFor="flexRadioDefault1">Expedited</label>
                </div>
                <div className="form-check" style={{ paddingTop: 8, width: `33%`, display: `inline-block` }}>
                  <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2" defaultChecked onClick={setExtSpeed} />
                  <label className="form-check-label" htmlFor="flexRadioDefault2">Standard</label>
                </div>
                <div className="form-check" style={{ paddingLeft: 0 }}>
                <label htmlFor="staticEmail" className="col-sm-4 col-form-label" style={{ width: `100%`}}>{speed}</label>
                </div>
              </div>
          </div>
        </div>
      </Modal>
      <Modal id={strModal} title="Change Storage Class" onClose={onCloseStrModal} onAction={() => onStoreClass(asset_id)} btnActionName="Change" btnActionDisabled={false} modalSize={'modal-lg'}>
        <Overlay display={processing} />
        <div className='col-md-12'>
          <div className='mb-3 row'>
            <div className='col-md-12'>
              <div className="alert alert-primary form-inline" role="alert" style={{ display: `inline-flex`}}>
                <i className="fas fa-info-circle mt-1 me-2"></i>
                If the selected folder contains files that are unrestored or restoring, the storage classes of these files are not changed.
              </div>
            </div>
          </div>
          <div className="mb-3 row">
            <div className="col-sm-12">
            <label htmlFor="staticEmail" className="col-form-label">Object Lists</label>  
              <table className='table'>
                <thead>
                  <tr>
                    <th></th>
                    <th>File Name</th>
                    <th>Storage Class</th>
                    <th>Size</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    !isEmpty(file) && Object.keys(file).map((key, i) => 
                      Array.isArray(file[key]) && file[key].map((item, j) => 
                        <tr key={'speed'+j}>
                          <td><input className="form-check-input" type="radio" name="flexRadioStr" id={'flexRadioStr_'+j}  defaultChecked={j === 0 ? true : false} value={key+'_'+j} onClick={setTypeFile} /></td>
                          <td>{truncate(item?.preview_url.split("/").pop().split('_')[1], 50)}</td>
                          <td>{item?.storage_class}</td>
                          <td>{item?.size  +' ' + item?.unit}</td>
                        </tr>
                      )
                    )
                  }
                  {
                    !isEmpty(file) && Object.keys(file).map((key, i) => 
                      !Array.isArray(file[key]) && (
                        <tr key={'speed'+i}>
                          <td><input className="form-check-input" type="radio" name="flexRadioStr" id={'flexRadioStr_'+i}  defaultChecked={i === 0 ? true : false} value={key+'_'+i} onClick={setTypeFile} /></td>
                          <td>{truncate(file[key]?.preview_url.split("/").pop().split('_')[1], 50)}</td>
                          <td>{file[key]?.storage_class}</td>
                          <td>{file[key]?.size  +' ' + file[key]?.unit}</td>
                        </tr>
                      ))
                  }
                </tbody>
              </table>
            </div>
          </div>
          <div className="mb-3 row">
              <label htmlFor="staticEmail" className="col-sm-3 col-form-label">Storage Class</label>
              <div className="col-sm-9">
                <div className="form-check" style={{ paddingTop: 8, width: `25%`, display: `inline-block` }}>
                  <input className="form-check-input" type="radio" name="flexRadioDefault1" id="flexRadioDefault3" defaultChecked onClick={setStdClass} />
                  <label className="form-check-label" htmlFor="flexRadioDefault3">Standard</label>
                </div>
                <div className="form-check" style={{ paddingTop: 8, width: `45%`, display: `inline-block` }}>
                  <input className="form-check-input" type="radio" name="flexRadioDefault1" id="flexRadioDefault4" onClick={setInfClass} />
                  <label className="form-check-label" htmlFor="flexRadioDefault4">Infrequent Access</label>
                </div>
                <div className="form-check" style={{ paddingTop: 8, width: `30%`, display: `inline-block` }}>
                  <input className="form-check-input" type="radio" name="flexRadioDefault1" id="flexRadioDefault5" onClick={setArhClass} />
                  <label className="form-check-label" htmlFor="flexRadioDefault5">Archive</label>
                </div>
                <div className="form-check" style={{ paddingLeft: 0 }}>
                <label htmlFor="staticEmail" className="col-sm-4 col-form-label" style={{ width: `100%`}}>{storage}</label>
                </div>
              </div>
          </div>
        </div>
      </Modal>
      <Modal id={aclModal} title="Change Access Control List (ACL)" onClose={onCloseAclModal} onAction={() => onSetAcl(asset_id)} btnActionName="Change" btnActionDisabled={false} modalSize={'modal-lg'}>
        <Overlay display={processing} />
        <div className='col-md-12'>
          <div className='mb-3 row'>
            <div className='col-md-12'>
              <div className="alert alert-primary form-inline" role="alert" style={{ display: `inline-flex`}}>
                <i className="fas fa-info-circle mt-1 me-2"></i>
                Setting a Pre-defined Access Control Policy for an Object with direct configuration
              </div>
            </div>
          </div>
          <div className="mb-3 row">
            <div className="col-sm-12">
            <label htmlFor="staticEmail" className="col-form-label">Object Lists</label>  
              <table className='table'>
                <thead>
                  <tr>
                    <th></th>
                    <th>File Name</th>
                    <th>ACL Class</th>
                    <th>Size</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    !isEmpty(file) && Object.keys(file).map((key, i) => 
                      Array.isArray(file[key]) && file[key].map((item, j) => 
                        <tr key={'speed'+j}>
                          <td><input className="form-check-input" type="radio" name="flexRadioAcl" id={'flexRadioAcl_'+j} defaultChecked={j === 0 ? true : false} value={key+'_'+j} onClick={setTypeFile} /></td>
                          <td>{truncate(item?.preview_url.split("/").pop().split('_')[1], 50)}</td>
                          <td>{item?.access}</td>
                          <td>{item?.size  +' ' + item?.unit}</td>
                        </tr>
                      )
                    )
                  }
                  {
                    !isEmpty(file) && Object.keys(file).map((key, i) => 
                      !Array.isArray(file[key]) && (
                        <tr key={'speed'+i}>
                          <td><input className="form-check-input" type="radio" name="flexRadioAcl" id={'flexRadioAcl_'+i} defaultChecked={i === 0 ? true : false} value={key+'_'+i} onClick={setTypeFile} /></td>
                          <td>{truncate(file[key]?.preview_url.split("/").pop().split('_')[1], 50)}</td>
                          <td>{file[key]?.access}</td>
                          <td>{file[key]?.size  +' ' + file[key]?.unit}</td>
                        </tr>
                      )
                    )
                  }
                </tbody>
              </table>
            </div>
          </div>
          <div className="mb-3 row">
              <label htmlFor="staticEmail" className="col-sm-3 col-form-label">Object ACL</label>
              <div className="col-sm-9">
                <div className="form-check" style={{ paddingTop: 8, width: `25%`, display: `inline-block` }}>
                  <input className="form-check-input" type="radio" name="flexRadioDefault2" id="flexRadioDefault6" defaultChecked onClick={setPrivateClass} />
                  <label className="form-check-label" htmlFor="flexRadioDefault3">Private</label>
                </div>
                <div className="form-check" style={{ paddingTop: 8, width: `45%`, display: `inline-block` }}>
                  <input className="form-check-input" type="radio" name="flexRadioDefault2" id="flexRadioDefault7" onClick={setPublicClass} />
                  <label className="form-check-label" htmlFor="flexRadioDefault4">Public</label>
                </div>
                <div className="form-check" style={{ paddingLeft: 0 }}>
                <label htmlFor="staticEmail" className="col-sm-4 col-form-label" style={{ width: `100%`}}>{acl}</label>
                </div>
              </div>
          </div>
        </div>
      </Modal>
      <Modal id={viewModal} title="Asset Details" onClose={onCloseViewModal} btnActionName="Change" btnActionDisabled={false} modalSize={'modal-lg'}>
        <Overlay display={processing} />
        <div className='col-md-12'>
          <div className="mb-3 row">
            <div className="col-sm-12">
            <label htmlFor="staticEmail" className="col-form-label">Asset Detail</label>  
              <div className="row mb-12">
                  <label htmlFor="title" className="col-sm-2 col-form-label">Title</label>
                  <label htmlFor="title" className="col-sm-10 col-form-label">: {asset.title}</label>
              </div>
              <div className="row mb-12">
                  <label htmlFor="title" className="col-sm-2 col-form-label">Discription</label>
                  <label htmlFor="title" className="col-sm-10 col-form-label">: {parser(asset?.description || '')}</label>
              </div>
              <div className="row mb-12">
                  <label htmlFor="title" className="col-sm-2 col-form-label">Hastag</label>
                  <label htmlFor="title" className="col-sm-10 col-form-label">: {asset.hastag}</label>
              </div>
              <div className="row mb-12">
                  <label htmlFor="title" className="col-sm-2 col-form-label">Month</label>
                  <label htmlFor="title" className="col-sm-10 col-form-label">: {asset.asset_month}</label>
              </div>
              <div className="row mb-12">
                  <label htmlFor="title" className="col-sm-2 col-form-label">Year</label>
                  <label htmlFor="title" className="col-sm-10 col-form-label">: {asset.asset_year}</label>
              </div>
              <div className="row mb-12">
                  <label htmlFor="title" className="col-sm-2 col-form-label">Asset Type</label>
                  <label htmlFor="title" className="col-sm-10 col-form-label">: {asset.type?.type_name}</label>
              </div> 
              <div className="row mb-12">
                  <label htmlFor="title" className="col-sm-2 col-form-label">Storage</label>
                  <label htmlFor="title" className="col-sm-10 col-form-label">: {asset.function?.function_name}</label>
              </div>
              <div className="row mb-12">
                  <label htmlFor="title" className="col-sm-2 col-form-label">Category</label>
                  <label htmlFor="title" className="col-sm-10 col-form-label">: {asset.category?.category_name}</label>
              </div>
              <div className="row mb-12">
                  <label htmlFor="title" className="col-sm-2 col-form-label">Brand</label>
                  <label htmlFor="title" className="col-sm-10 col-form-label">: {asset.brand}</label>
              </div>
              <div className="row mb-12">
                  <label htmlFor="title" className="col-sm-2 col-form-label">Asset Files</label>
                  <label htmlFor="title" className="col-sm-10 col-form-label">: Is Single ? {asset.is_single}</label>
              </div>
              <div className="row mb-12">
                  <table className='table'>
                    <thead>
                      <tr>
                        <th>Size Catg.</th>
                        <th>File Name</th>
                        <th>ACL Class</th>
                        <th>Size</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        !isEmpty(file) && Object.keys(file).length > 0 && Object.keys(file).map((key, i) => 
                          Array.isArray(file[key]) && file[key].map((item, j) => 
                            <tr key={'speed'+j}>
                              <td>{key.toUpperCase()}</td>
                              <td>{truncate(item?.preview_url.split("/").pop().split('_')[1], 50)}</td>
                              <td>{item?.access}</td>
                              <td>{item?.size  +' ' + item?.unit}</td>
                            </tr>
                          )
                        )
                      }
                      {
                        !isEmpty(file) && Object.keys(file).length > 0 && Object.keys(file).map((key, i) => 
                          !Array.isArray(file[key]) && (
                            <tr key={'speed'+i}>
                              <td>{key.toUpperCase()}</td>
                              <td>{truncate(file[key]?.preview_url.split("/").pop().split('_')[1], 50)}</td>
                              <td>{file[key]?.access}</td>
                              <td>{file[key]?.size  +' ' + file[key]?.unit}</td>
                            </tr>
                          )
                        )
                      }
                    </tbody>
                  </table> 
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default AssetScreen;